import { render, staticRenderFns } from "./ProductManufacturingOrigin.vue?vue&type=template&id=f660b424&"
import script from "./ProductManufacturingOrigin.vue?vue&type=script&lang=js&"
export * from "./ProductManufacturingOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports